// Console V0.1.130; 2026-10-02 20:51:43 CST; parent 5abb11ed04c30c2573a4557e316fd48d656507ca; CDN-RELIABILITY-20261002.
// 0.1.129; updated 2026-10-02 15:29:49 CST; parent f142a195884a186a912053e3a5175725bad58984.
// Console V0.1.129; 2026-10-02 13:32:09 CST; parent f142a195884a186a912053e3a5175725bad58984.
import { httpClient } from './client';
export interface DiagnosticDomain { id: number; domain: string; status: string }
export interface DiagnosticEntry {
 domainId: number; domain: string; ruleId: string; action: string; hits: number; blocked: number; firstHour: string; lastHour: string;
 guidance: { category: string; source: string; title: string; explanation: string; advice: string; href: string; actionLabel: string };
}
export interface AccessDiagnostics {
 window: { from: string; to: string; requestedFrom: string; requestedTo: string };
 domains: DiagnosticDomain[]; requests: number; abnormalResponses: number; blockedRequests: number;
 coverage: 'UNAVAILABLE' | 'PARTIAL' | 'COMPLETE'; coverageNote: string; thresholdNote: string;
 events: DiagnosticEntry[];
 responseStatuses: { domainId: number; domain: string; status: number; requests: number; firstHour: string; lastHour: string }[];
 configuredLimits?: { domainId: number; policyVersion: number; enabled: boolean; mode: string; limitsJson: string | null }[];
 excludedTests?: { domainId: number; nodeId: number; status: number; hour: string; requests: number; label: string }[];
 nodeFacts: { nodeId: number; domainId: number; ruleId: string; action: string; hits: number; blocked: number }[];
}
export const diagnosticsApi = {
 domains: () => httpClient.get<DiagnosticDomain[]>('/api/v1/log-center/diagnostics/domains'),
 query: (params: { domainId?: number; from: string; to: string }) => httpClient.get<AccessDiagnostics>('/api/v1/log-center/diagnostics', { params })
};
